/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TeamsLinkRouteImport } from './routes/teams-link'
import { Route as SetupAccountRouteImport } from './routes/setup-account'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ActivateRouteImport } from './routes/activate'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedMachineLogsRouteImport } from './routes/_authenticated/machine-logs'
import { Route as AuthenticatedLossRegisterRouteImport } from './routes/_authenticated/loss-register'
import { Route as AuthenticatedDataUploadRouteImport } from './routes/_authenticated/data-upload'
import { Route as AuthenticatedChatRouteImport } from './routes/_authenticated/_chat'
import { Route as Authenticated5RouteImport } from './routes/_authenticated/5'
import { Route as AuthenticatedSkillsRouteRouteImport } from './routes/_authenticated/skills/route'
import { Route as AuthenticatedSiteSettingsRouteRouteImport } from './routes/_authenticated/site-settings/route'
import { Route as AuthenticatedDashboardRouteRouteImport } from './routes/_authenticated/dashboard/route'
import { Route as AuthenticatedSkillsIndexRouteImport } from './routes/_authenticated/skills/index'
import { Route as AuthenticatedSiteSettingsIndexRouteImport } from './routes/_authenticated/site-settings/index'
import { Route as AuthenticatedLossDriversIndexRouteImport } from './routes/_authenticated/loss-drivers/index'
import { Route as AuthenticatedLibraryIndexRouteImport } from './routes/_authenticated/library/index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedChatIndexRouteImport } from './routes/_authenticated/_chat/index'
import { Route as AuthenticatedSkillsSharedRouteImport } from './routes/_authenticated/skills/shared'
import { Route as AuthenticatedSkillsNewRouteImport } from './routes/_authenticated/skills/new'
import { Route as AuthenticatedSkillsSkillIdRouteImport } from './routes/_authenticated/skills/$skillId'
import { Route as AuthenticatedSiteSettingsTeamRouteImport } from './routes/_authenticated/site-settings/team'
import { Route as AuthenticatedSiteSettingsTagsRouteImport } from './routes/_authenticated/site-settings/tags'
import { Route as AuthenticatedSiteSettingsFacilityRouteImport } from './routes/_authenticated/site-settings/facility'
import { Route as AuthenticatedSiteSettingsEquipmentRouteImport } from './routes/_authenticated/site-settings/equipment'
import { Route as AuthenticatedSiteSettingsConnectionsRouteImport } from './routes/_authenticated/site-settings/connections'
import { Route as AuthenticatedShareShareIdRouteImport } from './routes/_authenticated/share/$shareId'
import { Route as AuthenticatedLossDriversNewRouteImport } from './routes/_authenticated/loss-drivers/new'
import { Route as AuthenticatedLossDriversInvestigationIdRouteImport } from './routes/_authenticated/loss-drivers/$investigationId'
import { Route as AuthenticatedLibraryUploadsRouteImport } from './routes/_authenticated/library/uploads'
import { Route as AuthenticatedLibrarySharepointRouteImport } from './routes/_authenticated/library/sharepoint'
import { Route as AuthenticatedLibraryDocumentsRouteImport } from './routes/_authenticated/library/documents'
import { Route as AuthenticatedLibraryDocumentIdRouteImport } from './routes/_authenticated/library/$documentId'
import { Route as AuthenticatedDashboardUsageRouteImport } from './routes/_authenticated/dashboard/usage'
import { Route as AuthenticatedDashboardTriageRouteImport } from './routes/_authenticated/dashboard/triage'
import { Route as AuthenticatedDashboardRecentRouteImport } from './routes/_authenticated/dashboard/recent'
import { Route as AuthenticatedDashboardContentGapsRouteImport } from './routes/_authenticated/dashboard/content-gaps'
import { Route as AuthenticatedSkillsWorkflowsIndexRouteImport } from './routes/_authenticated/skills/workflows/index'
import { Route as AuthenticatedLibraryDocumentIdIndexRouteImport } from './routes/_authenticated/library/$documentId.index'
import { Route as AuthenticatedSkillsWorkflowsNewRouteImport } from './routes/_authenticated/skills/workflows/new'
import { Route as AuthenticatedSkillsWorkflowsWorkflowIdRouteImport } from './routes/_authenticated/skills/workflows/$workflowId'
import { Route as AuthenticatedLibraryFolderFolderIdRouteImport } from './routes/_authenticated/library/folder/$folderId'
import { Route as AuthenticatedLibraryDocumentIdMarkdownRouteImport } from './routes/_authenticated/library/$documentId.markdown'
import { Route as AuthenticatedLibraryDocumentIdImagesRouteImport } from './routes/_authenticated/library/$documentId.images'
import { Route as AuthenticatedLibraryDocumentIdChunksRouteImport } from './routes/_authenticated/library/$documentId.chunks'
import { Route as AuthenticatedFacilityShiftsShiftIdRouteImport } from './routes/_authenticated/facility/shifts.$shiftId'
import { Route as AuthenticatedFacilityLocationsLocationIdRouteImport } from './routes/_authenticated/facility/locations.$locationId'
import { Route as AuthenticatedFacilityLinesLineIdRouteImport } from './routes/_authenticated/facility/lines.$lineId'
import { Route as AuthenticatedDashboardConversationConversationIdRouteImport } from './routes/_authenticated/dashboard/conversation.$conversationId'
import { Route as AuthenticatedChatMachineEquipmentIdRouteImport } from './routes/_authenticated/_chat/machine.$equipmentId'
import { Route as AuthenticatedChatChatConversationIdRouteImport } from './routes/_authenticated/_chat/chat.$conversationId'

const TeamsLinkRoute = TeamsLinkRouteImport.update({
  id: '/teams-link',
  path: '/teams-link',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupAccountRoute = SetupAccountRouteImport.update({
  id: '/setup-account',
  path: '/setup-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateRoute = ActivateRouteImport.update({
  id: '/activate',
  path: '/activate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedMachineLogsRoute =
  AuthenticatedMachineLogsRouteImport.update({
    id: '/machine-logs',
    path: '/machine-logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLossRegisterRoute =
  AuthenticatedLossRegisterRouteImport.update({
    id: '/loss-register',
    path: '/loss-register',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDataUploadRoute = AuthenticatedDataUploadRouteImport.update({
  id: '/data-upload',
  path: '/data-upload',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChatRoute = AuthenticatedChatRouteImport.update({
  id: '/_chat',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const Authenticated5Route = Authenticated5RouteImport.update({
  id: '/5',
  path: '/5',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSkillsRouteRoute =
  AuthenticatedSkillsRouteRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiteSettingsRouteRoute =
  AuthenticatedSiteSettingsRouteRouteImport.update({
    id: '/site-settings',
    path: '/site-settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRouteRoute =
  AuthenticatedDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSkillsIndexRoute =
  AuthenticatedSkillsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsIndexRoute =
  AuthenticatedSiteSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedLossDriversIndexRoute =
  AuthenticatedLossDriversIndexRouteImport.update({
    id: '/loss-drivers/',
    path: '/loss-drivers/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibraryIndexRoute =
  AuthenticatedLibraryIndexRouteImport.update({
    id: '/library/',
    path: '/library/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedChatIndexRoute = AuthenticatedChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedChatRoute,
} as any)
const AuthenticatedSkillsSharedRoute =
  AuthenticatedSkillsSharedRouteImport.update({
    id: '/shared',
    path: '/shared',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedSkillsNewRoute = AuthenticatedSkillsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedSkillsRouteRoute,
} as any)
const AuthenticatedSkillsSkillIdRoute =
  AuthenticatedSkillsSkillIdRouteImport.update({
    id: '/$skillId',
    path: '/$skillId',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsTeamRoute =
  AuthenticatedSiteSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsTagsRoute =
  AuthenticatedSiteSettingsTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsFacilityRoute =
  AuthenticatedSiteSettingsFacilityRouteImport.update({
    id: '/facility',
    path: '/facility',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsEquipmentRoute =
  AuthenticatedSiteSettingsEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedSiteSettingsConnectionsRoute =
  AuthenticatedSiteSettingsConnectionsRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => AuthenticatedSiteSettingsRouteRoute,
  } as any)
const AuthenticatedShareShareIdRoute =
  AuthenticatedShareShareIdRouteImport.update({
    id: '/share/$shareId',
    path: '/share/$shareId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLossDriversNewRoute =
  AuthenticatedLossDriversNewRouteImport.update({
    id: '/loss-drivers/new',
    path: '/loss-drivers/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLossDriversInvestigationIdRoute =
  AuthenticatedLossDriversInvestigationIdRouteImport.update({
    id: '/loss-drivers/$investigationId',
    path: '/loss-drivers/$investigationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibraryUploadsRoute =
  AuthenticatedLibraryUploadsRouteImport.update({
    id: '/library/uploads',
    path: '/library/uploads',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibrarySharepointRoute =
  AuthenticatedLibrarySharepointRouteImport.update({
    id: '/library/sharepoint',
    path: '/library/sharepoint',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibraryDocumentsRoute =
  AuthenticatedLibraryDocumentsRouteImport.update({
    id: '/library/documents',
    path: '/library/documents',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibraryDocumentIdRoute =
  AuthenticatedLibraryDocumentIdRouteImport.update({
    id: '/library/$documentId',
    path: '/library/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardUsageRoute =
  AuthenticatedDashboardUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardTriageRoute =
  AuthenticatedDashboardTriageRouteImport.update({
    id: '/triage',
    path: '/triage',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardRecentRoute =
  AuthenticatedDashboardRecentRouteImport.update({
    id: '/recent',
    path: '/recent',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedDashboardContentGapsRoute =
  AuthenticatedDashboardContentGapsRouteImport.update({
    id: '/content-gaps',
    path: '/content-gaps',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedSkillsWorkflowsIndexRoute =
  AuthenticatedSkillsWorkflowsIndexRouteImport.update({
    id: '/workflows/',
    path: '/workflows/',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedLibraryDocumentIdIndexRoute =
  AuthenticatedLibraryDocumentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedLibraryDocumentIdRoute,
  } as any)
const AuthenticatedSkillsWorkflowsNewRoute =
  AuthenticatedSkillsWorkflowsNewRouteImport.update({
    id: '/workflows/new',
    path: '/workflows/new',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedSkillsWorkflowsWorkflowIdRoute =
  AuthenticatedSkillsWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AuthenticatedSkillsRouteRoute,
  } as any)
const AuthenticatedLibraryFolderFolderIdRoute =
  AuthenticatedLibraryFolderFolderIdRouteImport.update({
    id: '/library/folder/$folderId',
    path: '/library/folder/$folderId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLibraryDocumentIdMarkdownRoute =
  AuthenticatedLibraryDocumentIdMarkdownRouteImport.update({
    id: '/markdown',
    path: '/markdown',
    getParentRoute: () => AuthenticatedLibraryDocumentIdRoute,
  } as any)
const AuthenticatedLibraryDocumentIdImagesRoute =
  AuthenticatedLibraryDocumentIdImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => AuthenticatedLibraryDocumentIdRoute,
  } as any)
const AuthenticatedLibraryDocumentIdChunksRoute =
  AuthenticatedLibraryDocumentIdChunksRouteImport.update({
    id: '/chunks',
    path: '/chunks',
    getParentRoute: () => AuthenticatedLibraryDocumentIdRoute,
  } as any)
const AuthenticatedFacilityShiftsShiftIdRoute =
  AuthenticatedFacilityShiftsShiftIdRouteImport.update({
    id: '/facility/shifts/$shiftId',
    path: '/facility/shifts/$shiftId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFacilityLocationsLocationIdRoute =
  AuthenticatedFacilityLocationsLocationIdRouteImport.update({
    id: '/facility/locations/$locationId',
    path: '/facility/locations/$locationId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFacilityLinesLineIdRoute =
  AuthenticatedFacilityLinesLineIdRouteImport.update({
    id: '/facility/lines/$lineId',
    path: '/facility/lines/$lineId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardConversationConversationIdRoute =
  AuthenticatedDashboardConversationConversationIdRouteImport.update({
    id: '/conversation/$conversationId',
    path: '/conversation/$conversationId',
    getParentRoute: () => AuthenticatedDashboardRouteRoute,
  } as any)
const AuthenticatedChatMachineEquipmentIdRoute =
  AuthenticatedChatMachineEquipmentIdRouteImport.update({
    id: '/machine/$equipmentId',
    path: '/machine/$equipmentId',
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)
const AuthenticatedChatChatConversationIdRoute =
  AuthenticatedChatChatConversationIdRouteImport.update({
    id: '/chat/$conversationId',
    path: '/chat/$conversationId',
    getParentRoute: () => AuthenticatedChatRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedChatIndexRoute
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/teams-link': typeof TeamsLinkRoute
  '/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/site-settings': typeof AuthenticatedSiteSettingsRouteRouteWithChildren
  '/skills': typeof AuthenticatedSkillsRouteRouteWithChildren
  '/5': typeof Authenticated5Route
  '/data-upload': typeof AuthenticatedDataUploadRoute
  '/loss-register': typeof AuthenticatedLossRegisterRoute
  '/machine-logs': typeof AuthenticatedMachineLogsRoute
  '/dashboard/content-gaps': typeof AuthenticatedDashboardContentGapsRoute
  '/dashboard/recent': typeof AuthenticatedDashboardRecentRoute
  '/dashboard/triage': typeof AuthenticatedDashboardTriageRoute
  '/dashboard/usage': typeof AuthenticatedDashboardUsageRoute
  '/library/$documentId': typeof AuthenticatedLibraryDocumentIdRouteWithChildren
  '/library/documents': typeof AuthenticatedLibraryDocumentsRoute
  '/library/sharepoint': typeof AuthenticatedLibrarySharepointRoute
  '/library/uploads': typeof AuthenticatedLibraryUploadsRoute
  '/loss-drivers/$investigationId': typeof AuthenticatedLossDriversInvestigationIdRoute
  '/loss-drivers/new': typeof AuthenticatedLossDriversNewRoute
  '/share/$shareId': typeof AuthenticatedShareShareIdRoute
  '/site-settings/connections': typeof AuthenticatedSiteSettingsConnectionsRoute
  '/site-settings/equipment': typeof AuthenticatedSiteSettingsEquipmentRoute
  '/site-settings/facility': typeof AuthenticatedSiteSettingsFacilityRoute
  '/site-settings/tags': typeof AuthenticatedSiteSettingsTagsRoute
  '/site-settings/team': typeof AuthenticatedSiteSettingsTeamRoute
  '/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/skills/new': typeof AuthenticatedSkillsNewRoute
  '/skills/shared': typeof AuthenticatedSkillsSharedRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/library/': typeof AuthenticatedLibraryIndexRoute
  '/loss-drivers/': typeof AuthenticatedLossDriversIndexRoute
  '/site-settings/': typeof AuthenticatedSiteSettingsIndexRoute
  '/skills/': typeof AuthenticatedSkillsIndexRoute
  '/chat/$conversationId': typeof AuthenticatedChatChatConversationIdRoute
  '/machine/$equipmentId': typeof AuthenticatedChatMachineEquipmentIdRoute
  '/dashboard/conversation/$conversationId': typeof AuthenticatedDashboardConversationConversationIdRoute
  '/facility/lines/$lineId': typeof AuthenticatedFacilityLinesLineIdRoute
  '/facility/locations/$locationId': typeof AuthenticatedFacilityLocationsLocationIdRoute
  '/facility/shifts/$shiftId': typeof AuthenticatedFacilityShiftsShiftIdRoute
  '/library/$documentId/chunks': typeof AuthenticatedLibraryDocumentIdChunksRoute
  '/library/$documentId/images': typeof AuthenticatedLibraryDocumentIdImagesRoute
  '/library/$documentId/markdown': typeof AuthenticatedLibraryDocumentIdMarkdownRoute
  '/library/folder/$folderId': typeof AuthenticatedLibraryFolderFolderIdRoute
  '/skills/workflows/$workflowId': typeof AuthenticatedSkillsWorkflowsWorkflowIdRoute
  '/skills/workflows/new': typeof AuthenticatedSkillsWorkflowsNewRoute
  '/library/$documentId/': typeof AuthenticatedLibraryDocumentIdIndexRoute
  '/skills/workflows/': typeof AuthenticatedSkillsWorkflowsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedChatIndexRoute
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/teams-link': typeof TeamsLinkRoute
  '/5': typeof Authenticated5Route
  '/data-upload': typeof AuthenticatedDataUploadRoute
  '/loss-register': typeof AuthenticatedLossRegisterRoute
  '/machine-logs': typeof AuthenticatedMachineLogsRoute
  '/dashboard/content-gaps': typeof AuthenticatedDashboardContentGapsRoute
  '/dashboard/recent': typeof AuthenticatedDashboardRecentRoute
  '/dashboard/triage': typeof AuthenticatedDashboardTriageRoute
  '/dashboard/usage': typeof AuthenticatedDashboardUsageRoute
  '/library/documents': typeof AuthenticatedLibraryDocumentsRoute
  '/library/sharepoint': typeof AuthenticatedLibrarySharepointRoute
  '/library/uploads': typeof AuthenticatedLibraryUploadsRoute
  '/loss-drivers/$investigationId': typeof AuthenticatedLossDriversInvestigationIdRoute
  '/loss-drivers/new': typeof AuthenticatedLossDriversNewRoute
  '/share/$shareId': typeof AuthenticatedShareShareIdRoute
  '/site-settings/connections': typeof AuthenticatedSiteSettingsConnectionsRoute
  '/site-settings/equipment': typeof AuthenticatedSiteSettingsEquipmentRoute
  '/site-settings/facility': typeof AuthenticatedSiteSettingsFacilityRoute
  '/site-settings/tags': typeof AuthenticatedSiteSettingsTagsRoute
  '/site-settings/team': typeof AuthenticatedSiteSettingsTeamRoute
  '/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/skills/new': typeof AuthenticatedSkillsNewRoute
  '/skills/shared': typeof AuthenticatedSkillsSharedRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/library': typeof AuthenticatedLibraryIndexRoute
  '/loss-drivers': typeof AuthenticatedLossDriversIndexRoute
  '/site-settings': typeof AuthenticatedSiteSettingsIndexRoute
  '/skills': typeof AuthenticatedSkillsIndexRoute
  '/chat/$conversationId': typeof AuthenticatedChatChatConversationIdRoute
  '/machine/$equipmentId': typeof AuthenticatedChatMachineEquipmentIdRoute
  '/dashboard/conversation/$conversationId': typeof AuthenticatedDashboardConversationConversationIdRoute
  '/facility/lines/$lineId': typeof AuthenticatedFacilityLinesLineIdRoute
  '/facility/locations/$locationId': typeof AuthenticatedFacilityLocationsLocationIdRoute
  '/facility/shifts/$shiftId': typeof AuthenticatedFacilityShiftsShiftIdRoute
  '/library/$documentId/chunks': typeof AuthenticatedLibraryDocumentIdChunksRoute
  '/library/$documentId/images': typeof AuthenticatedLibraryDocumentIdImagesRoute
  '/library/$documentId/markdown': typeof AuthenticatedLibraryDocumentIdMarkdownRoute
  '/library/folder/$folderId': typeof AuthenticatedLibraryFolderFolderIdRoute
  '/skills/workflows/$workflowId': typeof AuthenticatedSkillsWorkflowsWorkflowIdRoute
  '/skills/workflows/new': typeof AuthenticatedSkillsWorkflowsNewRoute
  '/library/$documentId': typeof AuthenticatedLibraryDocumentIdIndexRoute
  '/skills/workflows': typeof AuthenticatedSkillsWorkflowsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate': typeof ActivateRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup-account': typeof SetupAccountRoute
  '/teams-link': typeof TeamsLinkRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteRouteWithChildren
  '/_authenticated/site-settings': typeof AuthenticatedSiteSettingsRouteRouteWithChildren
  '/_authenticated/skills': typeof AuthenticatedSkillsRouteRouteWithChildren
  '/_authenticated/5': typeof Authenticated5Route
  '/_authenticated/_chat': typeof AuthenticatedChatRouteWithChildren
  '/_authenticated/data-upload': typeof AuthenticatedDataUploadRoute
  '/_authenticated/loss-register': typeof AuthenticatedLossRegisterRoute
  '/_authenticated/machine-logs': typeof AuthenticatedMachineLogsRoute
  '/_authenticated/dashboard/content-gaps': typeof AuthenticatedDashboardContentGapsRoute
  '/_authenticated/dashboard/recent': typeof AuthenticatedDashboardRecentRoute
  '/_authenticated/dashboard/triage': typeof AuthenticatedDashboardTriageRoute
  '/_authenticated/dashboard/usage': typeof AuthenticatedDashboardUsageRoute
  '/_authenticated/library/$documentId': typeof AuthenticatedLibraryDocumentIdRouteWithChildren
  '/_authenticated/library/documents': typeof AuthenticatedLibraryDocumentsRoute
  '/_authenticated/library/sharepoint': typeof AuthenticatedLibrarySharepointRoute
  '/_authenticated/library/uploads': typeof AuthenticatedLibraryUploadsRoute
  '/_authenticated/loss-drivers/$investigationId': typeof AuthenticatedLossDriversInvestigationIdRoute
  '/_authenticated/loss-drivers/new': typeof AuthenticatedLossDriversNewRoute
  '/_authenticated/share/$shareId': typeof AuthenticatedShareShareIdRoute
  '/_authenticated/site-settings/connections': typeof AuthenticatedSiteSettingsConnectionsRoute
  '/_authenticated/site-settings/equipment': typeof AuthenticatedSiteSettingsEquipmentRoute
  '/_authenticated/site-settings/facility': typeof AuthenticatedSiteSettingsFacilityRoute
  '/_authenticated/site-settings/tags': typeof AuthenticatedSiteSettingsTagsRoute
  '/_authenticated/site-settings/team': typeof AuthenticatedSiteSettingsTeamRoute
  '/_authenticated/skills/$skillId': typeof AuthenticatedSkillsSkillIdRoute
  '/_authenticated/skills/new': typeof AuthenticatedSkillsNewRoute
  '/_authenticated/skills/shared': typeof AuthenticatedSkillsSharedRoute
  '/_authenticated/_chat/': typeof AuthenticatedChatIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/library/': typeof AuthenticatedLibraryIndexRoute
  '/_authenticated/loss-drivers/': typeof AuthenticatedLossDriversIndexRoute
  '/_authenticated/site-settings/': typeof AuthenticatedSiteSettingsIndexRoute
  '/_authenticated/skills/': typeof AuthenticatedSkillsIndexRoute
  '/_authenticated/_chat/chat/$conversationId': typeof AuthenticatedChatChatConversationIdRoute
  '/_authenticated/_chat/machine/$equipmentId': typeof AuthenticatedChatMachineEquipmentIdRoute
  '/_authenticated/dashboard/conversation/$conversationId': typeof AuthenticatedDashboardConversationConversationIdRoute
  '/_authenticated/facility/lines/$lineId': typeof AuthenticatedFacilityLinesLineIdRoute
  '/_authenticated/facility/locations/$locationId': typeof AuthenticatedFacilityLocationsLocationIdRoute
  '/_authenticated/facility/shifts/$shiftId': typeof AuthenticatedFacilityShiftsShiftIdRoute
  '/_authenticated/library/$documentId/chunks': typeof AuthenticatedLibraryDocumentIdChunksRoute
  '/_authenticated/library/$documentId/images': typeof AuthenticatedLibraryDocumentIdImagesRoute
  '/_authenticated/library/$documentId/markdown': typeof AuthenticatedLibraryDocumentIdMarkdownRoute
  '/_authenticated/library/folder/$folderId': typeof AuthenticatedLibraryFolderFolderIdRoute
  '/_authenticated/skills/workflows/$workflowId': typeof AuthenticatedSkillsWorkflowsWorkflowIdRoute
  '/_authenticated/skills/workflows/new': typeof AuthenticatedSkillsWorkflowsNewRoute
  '/_authenticated/library/$documentId/': typeof AuthenticatedLibraryDocumentIdIndexRoute
  '/_authenticated/skills/workflows/': typeof AuthenticatedSkillsWorkflowsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/setup-account'
    | '/teams-link'
    | '/dashboard'
    | '/site-settings'
    | '/skills'
    | '/5'
    | '/data-upload'
    | '/loss-register'
    | '/machine-logs'
    | '/dashboard/content-gaps'
    | '/dashboard/recent'
    | '/dashboard/triage'
    | '/dashboard/usage'
    | '/library/$documentId'
    | '/library/documents'
    | '/library/sharepoint'
    | '/library/uploads'
    | '/loss-drivers/$investigationId'
    | '/loss-drivers/new'
    | '/share/$shareId'
    | '/site-settings/connections'
    | '/site-settings/equipment'
    | '/site-settings/facility'
    | '/site-settings/tags'
    | '/site-settings/team'
    | '/skills/$skillId'
    | '/skills/new'
    | '/skills/shared'
    | '/dashboard/'
    | '/library/'
    | '/loss-drivers/'
    | '/site-settings/'
    | '/skills/'
    | '/chat/$conversationId'
    | '/machine/$equipmentId'
    | '/dashboard/conversation/$conversationId'
    | '/facility/lines/$lineId'
    | '/facility/locations/$locationId'
    | '/facility/shifts/$shiftId'
    | '/library/$documentId/chunks'
    | '/library/$documentId/images'
    | '/library/$documentId/markdown'
    | '/library/folder/$folderId'
    | '/skills/workflows/$workflowId'
    | '/skills/workflows/new'
    | '/library/$documentId/'
    | '/skills/workflows/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/setup-account'
    | '/teams-link'
    | '/5'
    | '/data-upload'
    | '/loss-register'
    | '/machine-logs'
    | '/dashboard/content-gaps'
    | '/dashboard/recent'
    | '/dashboard/triage'
    | '/dashboard/usage'
    | '/library/documents'
    | '/library/sharepoint'
    | '/library/uploads'
    | '/loss-drivers/$investigationId'
    | '/loss-drivers/new'
    | '/share/$shareId'
    | '/site-settings/connections'
    | '/site-settings/equipment'
    | '/site-settings/facility'
    | '/site-settings/tags'
    | '/site-settings/team'
    | '/skills/$skillId'
    | '/skills/new'
    | '/skills/shared'
    | '/dashboard'
    | '/library'
    | '/loss-drivers'
    | '/site-settings'
    | '/skills'
    | '/chat/$conversationId'
    | '/machine/$equipmentId'
    | '/dashboard/conversation/$conversationId'
    | '/facility/lines/$lineId'
    | '/facility/locations/$locationId'
    | '/facility/shifts/$shiftId'
    | '/library/$documentId/chunks'
    | '/library/$documentId/images'
    | '/library/$documentId/markdown'
    | '/library/folder/$folderId'
    | '/skills/workflows/$workflowId'
    | '/skills/workflows/new'
    | '/library/$documentId'
    | '/skills/workflows'
  id:
    | '__root__'
    | '/_authenticated'
    | '/activate'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/setup-account'
    | '/teams-link'
    | '/_authenticated/dashboard'
    | '/_authenticated/site-settings'
    | '/_authenticated/skills'
    | '/_authenticated/5'
    | '/_authenticated/_chat'
    | '/_authenticated/data-upload'
    | '/_authenticated/loss-register'
    | '/_authenticated/machine-logs'
    | '/_authenticated/dashboard/content-gaps'
    | '/_authenticated/dashboard/recent'
    | '/_authenticated/dashboard/triage'
    | '/_authenticated/dashboard/usage'
    | '/_authenticated/library/$documentId'
    | '/_authenticated/library/documents'
    | '/_authenticated/library/sharepoint'
    | '/_authenticated/library/uploads'
    | '/_authenticated/loss-drivers/$investigationId'
    | '/_authenticated/loss-drivers/new'
    | '/_authenticated/share/$shareId'
    | '/_authenticated/site-settings/connections'
    | '/_authenticated/site-settings/equipment'
    | '/_authenticated/site-settings/facility'
    | '/_authenticated/site-settings/tags'
    | '/_authenticated/site-settings/team'
    | '/_authenticated/skills/$skillId'
    | '/_authenticated/skills/new'
    | '/_authenticated/skills/shared'
    | '/_authenticated/_chat/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/library/'
    | '/_authenticated/loss-drivers/'
    | '/_authenticated/site-settings/'
    | '/_authenticated/skills/'
    | '/_authenticated/_chat/chat/$conversationId'
    | '/_authenticated/_chat/machine/$equipmentId'
    | '/_authenticated/dashboard/conversation/$conversationId'
    | '/_authenticated/facility/lines/$lineId'
    | '/_authenticated/facility/locations/$locationId'
    | '/_authenticated/facility/shifts/$shiftId'
    | '/_authenticated/library/$documentId/chunks'
    | '/_authenticated/library/$documentId/images'
    | '/_authenticated/library/$documentId/markdown'
    | '/_authenticated/library/folder/$folderId'
    | '/_authenticated/skills/workflows/$workflowId'
    | '/_authenticated/skills/workflows/new'
    | '/_authenticated/library/$documentId/'
    | '/_authenticated/skills/workflows/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateRoute: typeof ActivateRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupAccountRoute: typeof SetupAccountRoute
  TeamsLinkRoute: typeof TeamsLinkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/teams-link': {
      id: '/teams-link'
      path: '/teams-link'
      fullPath: '/teams-link'
      preLoaderRoute: typeof TeamsLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup-account': {
      id: '/setup-account'
      path: '/setup-account'
      fullPath: '/setup-account'
      preLoaderRoute: typeof SetupAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate': {
      id: '/activate'
      path: '/activate'
      fullPath: '/activate'
      preLoaderRoute: typeof ActivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/machine-logs': {
      id: '/_authenticated/machine-logs'
      path: '/machine-logs'
      fullPath: '/machine-logs'
      preLoaderRoute: typeof AuthenticatedMachineLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/loss-register': {
      id: '/_authenticated/loss-register'
      path: '/loss-register'
      fullPath: '/loss-register'
      preLoaderRoute: typeof AuthenticatedLossRegisterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data-upload': {
      id: '/_authenticated/data-upload'
      path: '/data-upload'
      fullPath: '/data-upload'
      preLoaderRoute: typeof AuthenticatedDataUploadRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_chat': {
      id: '/_authenticated/_chat'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedChatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/5': {
      id: '/_authenticated/5'
      path: '/5'
      fullPath: '/5'
      preLoaderRoute: typeof Authenticated5RouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills': {
      id: '/_authenticated/skills'
      path: '/skills'
      fullPath: '/skills'
      preLoaderRoute: typeof AuthenticatedSkillsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/site-settings': {
      id: '/_authenticated/site-settings'
      path: '/site-settings'
      fullPath: '/site-settings'
      preLoaderRoute: typeof AuthenticatedSiteSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/skills/': {
      id: '/_authenticated/skills/'
      path: '/'
      fullPath: '/skills/'
      preLoaderRoute: typeof AuthenticatedSkillsIndexRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/site-settings/': {
      id: '/_authenticated/site-settings/'
      path: '/'
      fullPath: '/site-settings/'
      preLoaderRoute: typeof AuthenticatedSiteSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/loss-drivers/': {
      id: '/_authenticated/loss-drivers/'
      path: '/loss-drivers'
      fullPath: '/loss-drivers/'
      preLoaderRoute: typeof AuthenticatedLossDriversIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/': {
      id: '/_authenticated/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof AuthenticatedLibraryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/_chat/': {
      id: '/_authenticated/_chat/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedChatIndexRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    '/_authenticated/skills/shared': {
      id: '/_authenticated/skills/shared'
      path: '/shared'
      fullPath: '/skills/shared'
      preLoaderRoute: typeof AuthenticatedSkillsSharedRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/skills/new': {
      id: '/_authenticated/skills/new'
      path: '/new'
      fullPath: '/skills/new'
      preLoaderRoute: typeof AuthenticatedSkillsNewRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/skills/$skillId': {
      id: '/_authenticated/skills/$skillId'
      path: '/$skillId'
      fullPath: '/skills/$skillId'
      preLoaderRoute: typeof AuthenticatedSkillsSkillIdRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/site-settings/team': {
      id: '/_authenticated/site-settings/team'
      path: '/team'
      fullPath: '/site-settings/team'
      preLoaderRoute: typeof AuthenticatedSiteSettingsTeamRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/site-settings/tags': {
      id: '/_authenticated/site-settings/tags'
      path: '/tags'
      fullPath: '/site-settings/tags'
      preLoaderRoute: typeof AuthenticatedSiteSettingsTagsRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/site-settings/facility': {
      id: '/_authenticated/site-settings/facility'
      path: '/facility'
      fullPath: '/site-settings/facility'
      preLoaderRoute: typeof AuthenticatedSiteSettingsFacilityRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/site-settings/equipment': {
      id: '/_authenticated/site-settings/equipment'
      path: '/equipment'
      fullPath: '/site-settings/equipment'
      preLoaderRoute: typeof AuthenticatedSiteSettingsEquipmentRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/site-settings/connections': {
      id: '/_authenticated/site-settings/connections'
      path: '/connections'
      fullPath: '/site-settings/connections'
      preLoaderRoute: typeof AuthenticatedSiteSettingsConnectionsRouteImport
      parentRoute: typeof AuthenticatedSiteSettingsRouteRoute
    }
    '/_authenticated/share/$shareId': {
      id: '/_authenticated/share/$shareId'
      path: '/share/$shareId'
      fullPath: '/share/$shareId'
      preLoaderRoute: typeof AuthenticatedShareShareIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/loss-drivers/new': {
      id: '/_authenticated/loss-drivers/new'
      path: '/loss-drivers/new'
      fullPath: '/loss-drivers/new'
      preLoaderRoute: typeof AuthenticatedLossDriversNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/loss-drivers/$investigationId': {
      id: '/_authenticated/loss-drivers/$investigationId'
      path: '/loss-drivers/$investigationId'
      fullPath: '/loss-drivers/$investigationId'
      preLoaderRoute: typeof AuthenticatedLossDriversInvestigationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/uploads': {
      id: '/_authenticated/library/uploads'
      path: '/library/uploads'
      fullPath: '/library/uploads'
      preLoaderRoute: typeof AuthenticatedLibraryUploadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/sharepoint': {
      id: '/_authenticated/library/sharepoint'
      path: '/library/sharepoint'
      fullPath: '/library/sharepoint'
      preLoaderRoute: typeof AuthenticatedLibrarySharepointRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/documents': {
      id: '/_authenticated/library/documents'
      path: '/library/documents'
      fullPath: '/library/documents'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/$documentId': {
      id: '/_authenticated/library/$documentId'
      path: '/library/$documentId'
      fullPath: '/library/$documentId'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/usage': {
      id: '/_authenticated/dashboard/usage'
      path: '/usage'
      fullPath: '/dashboard/usage'
      preLoaderRoute: typeof AuthenticatedDashboardUsageRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/triage': {
      id: '/_authenticated/dashboard/triage'
      path: '/triage'
      fullPath: '/dashboard/triage'
      preLoaderRoute: typeof AuthenticatedDashboardTriageRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/recent': {
      id: '/_authenticated/dashboard/recent'
      path: '/recent'
      fullPath: '/dashboard/recent'
      preLoaderRoute: typeof AuthenticatedDashboardRecentRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/dashboard/content-gaps': {
      id: '/_authenticated/dashboard/content-gaps'
      path: '/content-gaps'
      fullPath: '/dashboard/content-gaps'
      preLoaderRoute: typeof AuthenticatedDashboardContentGapsRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/skills/workflows/': {
      id: '/_authenticated/skills/workflows/'
      path: '/workflows'
      fullPath: '/skills/workflows/'
      preLoaderRoute: typeof AuthenticatedSkillsWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/library/$documentId/': {
      id: '/_authenticated/library/$documentId/'
      path: '/'
      fullPath: '/library/$documentId/'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentIdIndexRouteImport
      parentRoute: typeof AuthenticatedLibraryDocumentIdRoute
    }
    '/_authenticated/skills/workflows/new': {
      id: '/_authenticated/skills/workflows/new'
      path: '/workflows/new'
      fullPath: '/skills/workflows/new'
      preLoaderRoute: typeof AuthenticatedSkillsWorkflowsNewRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/skills/workflows/$workflowId': {
      id: '/_authenticated/skills/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/skills/workflows/$workflowId'
      preLoaderRoute: typeof AuthenticatedSkillsWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedSkillsRouteRoute
    }
    '/_authenticated/library/folder/$folderId': {
      id: '/_authenticated/library/folder/$folderId'
      path: '/library/folder/$folderId'
      fullPath: '/library/folder/$folderId'
      preLoaderRoute: typeof AuthenticatedLibraryFolderFolderIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/library/$documentId/markdown': {
      id: '/_authenticated/library/$documentId/markdown'
      path: '/markdown'
      fullPath: '/library/$documentId/markdown'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentIdMarkdownRouteImport
      parentRoute: typeof AuthenticatedLibraryDocumentIdRoute
    }
    '/_authenticated/library/$documentId/images': {
      id: '/_authenticated/library/$documentId/images'
      path: '/images'
      fullPath: '/library/$documentId/images'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentIdImagesRouteImport
      parentRoute: typeof AuthenticatedLibraryDocumentIdRoute
    }
    '/_authenticated/library/$documentId/chunks': {
      id: '/_authenticated/library/$documentId/chunks'
      path: '/chunks'
      fullPath: '/library/$documentId/chunks'
      preLoaderRoute: typeof AuthenticatedLibraryDocumentIdChunksRouteImport
      parentRoute: typeof AuthenticatedLibraryDocumentIdRoute
    }
    '/_authenticated/facility/shifts/$shiftId': {
      id: '/_authenticated/facility/shifts/$shiftId'
      path: '/facility/shifts/$shiftId'
      fullPath: '/facility/shifts/$shiftId'
      preLoaderRoute: typeof AuthenticatedFacilityShiftsShiftIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facility/locations/$locationId': {
      id: '/_authenticated/facility/locations/$locationId'
      path: '/facility/locations/$locationId'
      fullPath: '/facility/locations/$locationId'
      preLoaderRoute: typeof AuthenticatedFacilityLocationsLocationIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facility/lines/$lineId': {
      id: '/_authenticated/facility/lines/$lineId'
      path: '/facility/lines/$lineId'
      fullPath: '/facility/lines/$lineId'
      preLoaderRoute: typeof AuthenticatedFacilityLinesLineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/conversation/$conversationId': {
      id: '/_authenticated/dashboard/conversation/$conversationId'
      path: '/conversation/$conversationId'
      fullPath: '/dashboard/conversation/$conversationId'
      preLoaderRoute: typeof AuthenticatedDashboardConversationConversationIdRouteImport
      parentRoute: typeof AuthenticatedDashboardRouteRoute
    }
    '/_authenticated/_chat/machine/$equipmentId': {
      id: '/_authenticated/_chat/machine/$equipmentId'
      path: '/machine/$equipmentId'
      fullPath: '/machine/$equipmentId'
      preLoaderRoute: typeof AuthenticatedChatMachineEquipmentIdRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
    '/_authenticated/_chat/chat/$conversationId': {
      id: '/_authenticated/_chat/chat/$conversationId'
      path: '/chat/$conversationId'
      fullPath: '/chat/$conversationId'
      preLoaderRoute: typeof AuthenticatedChatChatConversationIdRouteImport
      parentRoute: typeof AuthenticatedChatRoute
    }
  }
}

interface AuthenticatedDashboardRouteRouteChildren {
  AuthenticatedDashboardContentGapsRoute: typeof AuthenticatedDashboardContentGapsRoute
  AuthenticatedDashboardRecentRoute: typeof AuthenticatedDashboardRecentRoute
  AuthenticatedDashboardTriageRoute: typeof AuthenticatedDashboardTriageRoute
  AuthenticatedDashboardUsageRoute: typeof AuthenticatedDashboardUsageRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDashboardConversationConversationIdRoute: typeof AuthenticatedDashboardConversationConversationIdRoute
}

const AuthenticatedDashboardRouteRouteChildren: AuthenticatedDashboardRouteRouteChildren =
  {
    AuthenticatedDashboardContentGapsRoute:
      AuthenticatedDashboardContentGapsRoute,
    AuthenticatedDashboardRecentRoute: AuthenticatedDashboardRecentRoute,
    AuthenticatedDashboardTriageRoute: AuthenticatedDashboardTriageRoute,
    AuthenticatedDashboardUsageRoute: AuthenticatedDashboardUsageRoute,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
    AuthenticatedDashboardConversationConversationIdRoute:
      AuthenticatedDashboardConversationConversationIdRoute,
  }

const AuthenticatedDashboardRouteRouteWithChildren =
  AuthenticatedDashboardRouteRoute._addFileChildren(
    AuthenticatedDashboardRouteRouteChildren,
  )

interface AuthenticatedSiteSettingsRouteRouteChildren {
  AuthenticatedSiteSettingsConnectionsRoute: typeof AuthenticatedSiteSettingsConnectionsRoute
  AuthenticatedSiteSettingsEquipmentRoute: typeof AuthenticatedSiteSettingsEquipmentRoute
  AuthenticatedSiteSettingsFacilityRoute: typeof AuthenticatedSiteSettingsFacilityRoute
  AuthenticatedSiteSettingsTagsRoute: typeof AuthenticatedSiteSettingsTagsRoute
  AuthenticatedSiteSettingsTeamRoute: typeof AuthenticatedSiteSettingsTeamRoute
  AuthenticatedSiteSettingsIndexRoute: typeof AuthenticatedSiteSettingsIndexRoute
}

const AuthenticatedSiteSettingsRouteRouteChildren: AuthenticatedSiteSettingsRouteRouteChildren =
  {
    AuthenticatedSiteSettingsConnectionsRoute:
      AuthenticatedSiteSettingsConnectionsRoute,
    AuthenticatedSiteSettingsEquipmentRoute:
      AuthenticatedSiteSettingsEquipmentRoute,
    AuthenticatedSiteSettingsFacilityRoute:
      AuthenticatedSiteSettingsFacilityRoute,
    AuthenticatedSiteSettingsTagsRoute: AuthenticatedSiteSettingsTagsRoute,
    AuthenticatedSiteSettingsTeamRoute: AuthenticatedSiteSettingsTeamRoute,
    AuthenticatedSiteSettingsIndexRoute: AuthenticatedSiteSettingsIndexRoute,
  }

const AuthenticatedSiteSettingsRouteRouteWithChildren =
  AuthenticatedSiteSettingsRouteRoute._addFileChildren(
    AuthenticatedSiteSettingsRouteRouteChildren,
  )

interface AuthenticatedSkillsRouteRouteChildren {
  AuthenticatedSkillsSkillIdRoute: typeof AuthenticatedSkillsSkillIdRoute
  AuthenticatedSkillsNewRoute: typeof AuthenticatedSkillsNewRoute
  AuthenticatedSkillsSharedRoute: typeof AuthenticatedSkillsSharedRoute
  AuthenticatedSkillsIndexRoute: typeof AuthenticatedSkillsIndexRoute
  AuthenticatedSkillsWorkflowsWorkflowIdRoute: typeof AuthenticatedSkillsWorkflowsWorkflowIdRoute
  AuthenticatedSkillsWorkflowsNewRoute: typeof AuthenticatedSkillsWorkflowsNewRoute
  AuthenticatedSkillsWorkflowsIndexRoute: typeof AuthenticatedSkillsWorkflowsIndexRoute
}

const AuthenticatedSkillsRouteRouteChildren: AuthenticatedSkillsRouteRouteChildren =
  {
    AuthenticatedSkillsSkillIdRoute: AuthenticatedSkillsSkillIdRoute,
    AuthenticatedSkillsNewRoute: AuthenticatedSkillsNewRoute,
    AuthenticatedSkillsSharedRoute: AuthenticatedSkillsSharedRoute,
    AuthenticatedSkillsIndexRoute: AuthenticatedSkillsIndexRoute,
    AuthenticatedSkillsWorkflowsWorkflowIdRoute:
      AuthenticatedSkillsWorkflowsWorkflowIdRoute,
    AuthenticatedSkillsWorkflowsNewRoute: AuthenticatedSkillsWorkflowsNewRoute,
    AuthenticatedSkillsWorkflowsIndexRoute:
      AuthenticatedSkillsWorkflowsIndexRoute,
  }

const AuthenticatedSkillsRouteRouteWithChildren =
  AuthenticatedSkillsRouteRoute._addFileChildren(
    AuthenticatedSkillsRouteRouteChildren,
  )

interface AuthenticatedChatRouteChildren {
  AuthenticatedChatIndexRoute: typeof AuthenticatedChatIndexRoute
  AuthenticatedChatChatConversationIdRoute: typeof AuthenticatedChatChatConversationIdRoute
  AuthenticatedChatMachineEquipmentIdRoute: typeof AuthenticatedChatMachineEquipmentIdRoute
}

const AuthenticatedChatRouteChildren: AuthenticatedChatRouteChildren = {
  AuthenticatedChatIndexRoute: AuthenticatedChatIndexRoute,
  AuthenticatedChatChatConversationIdRoute:
    AuthenticatedChatChatConversationIdRoute,
  AuthenticatedChatMachineEquipmentIdRoute:
    AuthenticatedChatMachineEquipmentIdRoute,
}

const AuthenticatedChatRouteWithChildren =
  AuthenticatedChatRoute._addFileChildren(AuthenticatedChatRouteChildren)

interface AuthenticatedLibraryDocumentIdRouteChildren {
  AuthenticatedLibraryDocumentIdChunksRoute: typeof AuthenticatedLibraryDocumentIdChunksRoute
  AuthenticatedLibraryDocumentIdImagesRoute: typeof AuthenticatedLibraryDocumentIdImagesRoute
  AuthenticatedLibraryDocumentIdMarkdownRoute: typeof AuthenticatedLibraryDocumentIdMarkdownRoute
  AuthenticatedLibraryDocumentIdIndexRoute: typeof AuthenticatedLibraryDocumentIdIndexRoute
}

const AuthenticatedLibraryDocumentIdRouteChildren: AuthenticatedLibraryDocumentIdRouteChildren =
  {
    AuthenticatedLibraryDocumentIdChunksRoute:
      AuthenticatedLibraryDocumentIdChunksRoute,
    AuthenticatedLibraryDocumentIdImagesRoute:
      AuthenticatedLibraryDocumentIdImagesRoute,
    AuthenticatedLibraryDocumentIdMarkdownRoute:
      AuthenticatedLibraryDocumentIdMarkdownRoute,
    AuthenticatedLibraryDocumentIdIndexRoute:
      AuthenticatedLibraryDocumentIdIndexRoute,
  }

const AuthenticatedLibraryDocumentIdRouteWithChildren =
  AuthenticatedLibraryDocumentIdRoute._addFileChildren(
    AuthenticatedLibraryDocumentIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRouteRoute: typeof AuthenticatedDashboardRouteRouteWithChildren
  AuthenticatedSiteSettingsRouteRoute: typeof AuthenticatedSiteSettingsRouteRouteWithChildren
  AuthenticatedSkillsRouteRoute: typeof AuthenticatedSkillsRouteRouteWithChildren
  Authenticated5Route: typeof Authenticated5Route
  AuthenticatedChatRoute: typeof AuthenticatedChatRouteWithChildren
  AuthenticatedDataUploadRoute: typeof AuthenticatedDataUploadRoute
  AuthenticatedLossRegisterRoute: typeof AuthenticatedLossRegisterRoute
  AuthenticatedMachineLogsRoute: typeof AuthenticatedMachineLogsRoute
  AuthenticatedLibraryDocumentIdRoute: typeof AuthenticatedLibraryDocumentIdRouteWithChildren
  AuthenticatedLibraryDocumentsRoute: typeof AuthenticatedLibraryDocumentsRoute
  AuthenticatedLibrarySharepointRoute: typeof AuthenticatedLibrarySharepointRoute
  AuthenticatedLibraryUploadsRoute: typeof AuthenticatedLibraryUploadsRoute
  AuthenticatedLossDriversInvestigationIdRoute: typeof AuthenticatedLossDriversInvestigationIdRoute
  AuthenticatedLossDriversNewRoute: typeof AuthenticatedLossDriversNewRoute
  AuthenticatedShareShareIdRoute: typeof AuthenticatedShareShareIdRoute
  AuthenticatedLibraryIndexRoute: typeof AuthenticatedLibraryIndexRoute
  AuthenticatedLossDriversIndexRoute: typeof AuthenticatedLossDriversIndexRoute
  AuthenticatedFacilityLinesLineIdRoute: typeof AuthenticatedFacilityLinesLineIdRoute
  AuthenticatedFacilityLocationsLocationIdRoute: typeof AuthenticatedFacilityLocationsLocationIdRoute
  AuthenticatedFacilityShiftsShiftIdRoute: typeof AuthenticatedFacilityShiftsShiftIdRoute
  AuthenticatedLibraryFolderFolderIdRoute: typeof AuthenticatedLibraryFolderFolderIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRouteRoute:
    AuthenticatedDashboardRouteRouteWithChildren,
  AuthenticatedSiteSettingsRouteRoute:
    AuthenticatedSiteSettingsRouteRouteWithChildren,
  AuthenticatedSkillsRouteRoute: AuthenticatedSkillsRouteRouteWithChildren,
  Authenticated5Route: Authenticated5Route,
  AuthenticatedChatRoute: AuthenticatedChatRouteWithChildren,
  AuthenticatedDataUploadRoute: AuthenticatedDataUploadRoute,
  AuthenticatedLossRegisterRoute: AuthenticatedLossRegisterRoute,
  AuthenticatedMachineLogsRoute: AuthenticatedMachineLogsRoute,
  AuthenticatedLibraryDocumentIdRoute:
    AuthenticatedLibraryDocumentIdRouteWithChildren,
  AuthenticatedLibraryDocumentsRoute: AuthenticatedLibraryDocumentsRoute,
  AuthenticatedLibrarySharepointRoute: AuthenticatedLibrarySharepointRoute,
  AuthenticatedLibraryUploadsRoute: AuthenticatedLibraryUploadsRoute,
  AuthenticatedLossDriversInvestigationIdRoute:
    AuthenticatedLossDriversInvestigationIdRoute,
  AuthenticatedLossDriversNewRoute: AuthenticatedLossDriversNewRoute,
  AuthenticatedShareShareIdRoute: AuthenticatedShareShareIdRoute,
  AuthenticatedLibraryIndexRoute: AuthenticatedLibraryIndexRoute,
  AuthenticatedLossDriversIndexRoute: AuthenticatedLossDriversIndexRoute,
  AuthenticatedFacilityLinesLineIdRoute: AuthenticatedFacilityLinesLineIdRoute,
  AuthenticatedFacilityLocationsLocationIdRoute:
    AuthenticatedFacilityLocationsLocationIdRoute,
  AuthenticatedFacilityShiftsShiftIdRoute:
    AuthenticatedFacilityShiftsShiftIdRoute,
  AuthenticatedLibraryFolderFolderIdRoute:
    AuthenticatedLibraryFolderFolderIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateRoute: ActivateRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupAccountRoute: SetupAccountRoute,
  TeamsLinkRoute: TeamsLinkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
